// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: Lato, Lucida Sans Unicode, Lucida Grande, sans-serif !important;
  font-size: 14px !important;
}

.popup-container.transcript .center-container {
  overflow: hidden;
}

.popup-content.fixed.vertical-transcript, .popup-content.fixed.vertical-transcript-sm{
  display: flex !important;
  overflow:unset !important;
}

.captions-canvas.visible-ui.transcription-enabled {
  width: calc(100vw - 40%) !important;
  right: 20% !important;
}

.captions-canvas.visible-ui.transcription-enabled div.text-container {
  left: 25% !important;
}

.popup-content.fixed.vertical-transcript{
  width: 40% !important;
  height: calc(100vh - var(--playback-bar-height) - 80px) !important;
  right: 0px !important;
  background-color: var(--main-bg-color) !important;
  top: 0px !important;
}

.popup-content.fixed.vertical-transcript-sm{
  width: 40% !important;
  height: calc(100vh - var(--playback-bar-height) - 80px) !important;
  right: 0px !important;
  background-color: var(--main-bg-color) !important;
  top: 0px !important;
}

.base-video-rect.dynamic.portrait.transcription {
    right: 15% !important;
    gap: 0 !important;
}

.base-video-rect.dynamic.portrait.transcription-sm {
  right: 15%;
  margin-left: 0px;
  width: calc(100vw - 45%) !important;
  gap: 0 !important;
}

.trancription-plugin-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.popup-content.fixed.vertical-transcript .center-container .ai-declaration {
  text-align: right;
  color: lightgray;
  font-size: x-small;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tab-pane {
  overflow: hidden;
  display: flex;

}

.tab-pane .transcript-text p span.result-item {
  cursor: pointer;
  color: white;
  margin: 0 2px;
  display: inline;
}

.tab-pane .input-container {
  position: relative;
  display: inline-block;
  display: flex;
  flex-shrink: 0;
}

.tab-pane .input-container .search-input {
  flex: 1;
  padding-right: 30px;
}

.clear-button {
  position: absolute;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  transform: translateY(-50%);
  top: 50%;
}

.clear-button:hover {
  color: #333; 
}

.tab-pane input {
  padding-left: 10px;
  width: 100%;
  height: var(--find-captions-plugin-search-bar-height);
  border-radius: 5px;
  border: 1px solid #ccc;
  float: right;
  box-sizing: border-box;
}

.tab-pane .search-button {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.tab-pane .search-button:hover {
  color: #333; 
}

.tab-pane .search-content {
    margin-bottom: 10px;
}

.tab-pane .transcript-text {
  clear: both;
}

.tab-pane .transcript-text::before {
  height: 20px;
  content: "";
}

.tab-pane .transcript-text p span.result-item.current {
  background-color: var(--highlight-bg-color-hover);
  margin: 0 2px;
}

.tab-pane .transcript-text .highlight {
  background-color: coral;
}

.tab-pane .transcript-text .current-highlight {
  background-color: yellow;
}

.tab-content {
  display: flex;
  flex-direction: column;
  padding: 5px 0px; 
  position: relative;
  overflow: hidden;
  height: calc(100vh - var(--playback-bar-height) - 180px);
}

.tab-contents {
  flex-grow: 1;
  overflow-y: auto;
  margin-top: 3%;
  max-height: 100%; 
}

.ai-model-text {
  position: relative;
}

.ai-model {
  color: lightgray; 
  font-size: 12px;
  text-align: center;
  display: block;
  flex-shrink: 0;
}

.ai-model button {
  color: white;
  background: none!important;
  border: none;
  padding: 0!important;
  text-decoration: underline;
  cursor: pointer;
}

.ai-model .tab-icon svg{
  font-size: 12px;
  fill: lightgray;
  vertical-align: middle;
  width: 12px;
  height: 12px;
}

.icon-description-list {
  padding: 0;
  list-style-type: none;
}

.icon-description-list li {
  margin: 8px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.icon-description-list li .tab-icon {
  margin-right: 8px;
  width: 1em;
  height: 1em;
  cursor: pointer;
  border: none;
  background: none;
  fill: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs {
  display: flex;
  padding: 20px 50px;
  position: relative;
  align-items: center;
}

.tab-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.left-tabs {
  display: flex;
}

.right-tabs {
  display: flex;
  margin-left: auto;
  margin-right: 10px;
}

.tab-button {
  cursor: pointer;
  border: none;
  align-items: center;
  text-align: center;
  background: none;
  padding-top: 0.25rem;
}

.tab-button .tab-icon {
  display: inline-block;
  width: var(--button-icon-size);
  cursor: pointer;
  border: none;
  background: none;
  fill: white;
}


.tab-button:hover {
  background-color: var(--highlight-bg-color-hover);
  color: white;
  border-radius: 5px;
}

.tab-button.active {
    background-color: var(--highlight-bg-color-hover);
    color: white;
    border-radius: 5px;
}

.tab-content .tab-pane {
  display: none;
}


.tab-content .tab-pane.active {
  display: flex;
  max-height: calc(100vh - var(--playback-bar-height) - 95px) !important;
  padding: 5px 10px;
  flex-direction: column;
}

.tab-pane .dropdown-container .summary-language-dropdown {
  width: 100%;
  padding: 0 10px;
  border-radius: 5px;
  height: var(--find-captions-plugin-search-bar-height);
  float: right;
}

.tab-pane .summary-text {
  clear: both;
}

.tab-content .tab-pane div {
  color: white;
  padding-top: 1%;
}

.tab-open .dropdown-open .summary-language-dropdown {
  display: block;
}

.tab-pane .dropdown-open .dropdown-icon {
  display: none;
}

.tabs-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid white;
  padding-bottom: 10px;
  padding-top: 25px;
  position: sticky;
  z-index: 9999;
}

.burger-menu {
  display: none;
}

.dropdown-menu {
  display: none;
}

.burger-menu.active .dropdown-menu {
  display: block;
  position: absolute;
  background: var(--main-bg-color);
  border: 1px solid var(--main-bg-color);
  z-index: 1000; 
  right: 0px; 
}

.dropdown-menu button {
  padding: 10px;
}

.menu-button {
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

@media (max-width: 359px) {
  .summary-language-dropdown {
    width: 100% !important;
  }
	
  .right-tabs .tab-button {
    display: none;
  }

  .burger-menu {
    display: block;
    margin-left: auto;
    position: absolute;
    float: right !important;
  }

  .dropdown-menu .tab-button .tab-icon {
    width: 1.1rem;
  }
}

/* Medium screens (360px to 430px) */
@media (min-width: 360px) and (max-width: 430px) {
   .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 79px) !important;
    width: 40% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 135px) !important;
    width: 50% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 155px) !important;
  }

  .summary-language-dropdown {
    width: 100% !important;
  }

  .right-tabs .tab-button {
    display: none;
  }

  .tabs-container {
    padding-top: 35px !important;
  }

  .burger-menu {
    display: block;
    margin-left: auto;
    position: absolute;
    float: right !important;
  }

  .dropdown-menu .tab-button .tab-icon {
    width: 1.1rem;
  }
}

/* Large screens (431px and above) */
@media (min-width: 431px) and (max-width: 539px) {
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 78px) !important;
    width: 40% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 118px) !important;
    width: 40% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 175px) !important;
  }

  .summary-language-dropdown {
    width: 100% !important;
  }

  .right-tabs .tab-button {
    display: none;
  }

  .burger-menu {
    display: block;
    margin-left: auto;
    position: absolute;
    float: right !important;
  }

  .dropdown-menu .tab-button .tab-icon {
    width: 1.1rem;
  }
}

@media (min-width: 540px) and (max-width: 719px) {
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 33px) !important;
    width: 35% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 158px) !important;
  }

  .summary-language-dropdown {
    width: 80% !important;
  }

  .right-tabs .tab-button {
    display: none;
  }

  .burger-menu {
    display: block;
    margin-left: auto;
    position: absolute;
    float: right !important;
  }

  .dropdown-menu .tab-button .tab-icon {
    width: 1.1rem;
  }

}

@media (min-height: 720px) and (min-width: 540px) and (max-width: 767px){ 
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 80px) !important;
    width: 35% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 80px) !important;
  }
}

/* Specific styles for iPads (or tablets) */
@media (min-width: 768px) and (max-width: 1023px) {
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 122px) !important;
  }
  .right-tabs .tab-button {
    display: block;
  }

  .burger-menu {
    display: none;
  }

  .tab-button .tab-icon {
    width: 1.1rem;
  }
}

@media (min-width: 1024px) {
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 115px) !important;
  }

  .summary-language-dropdown {
    width: 40% !important;
  }

  .right-tabs .tab-button {
    display: block;
  }

  .burger-menu {
    display: none;
  }
}

@media (min-width: 1280px) {
  .popup-content.fixed.vertical-transcript-sm {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 35% !important;
  }

  .popup-content.fixed.vertical-transcript {
    height: calc(100vh - var(--playback-bar-height) - 32px) !important;
    width: 30% !important;
  }

  .tab-content {
    height: calc(100vh - var(--playback-bar-height) - 115px) !important;
  }

  .right-tabs .tab-button {
    display: block;
  }

  .summary-language-dropdown {
    width: 40% !important;
  }

  .burger-menu {
    display: none;
  }

}

`, "",{"version":3,"sources":["webpack://./src/css/TranscriptionPlugin.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;EAClE,qBAAqB;EACrB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;EAClE,qBAAqB;EACrB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;;AAEf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qDAAqD;EACrD,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;IACI,iDAAiD;IACjD,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,sEAAsE;EACtE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;GACG;IACC,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;IACnE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;IACnE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;EACA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,kEAAkE;IAClE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":["html {\n  font-family: Lato, Lucida Sans Unicode, Lucida Grande, sans-serif !important;\n  font-size: 14px !important;\n}\n\n.popup-container.transcript .center-container {\n  overflow: hidden;\n}\n\n.popup-content.fixed.vertical-transcript, .popup-content.fixed.vertical-transcript-sm{\n  display: flex !important;\n  overflow:unset !important;\n}\n\n.captions-canvas.visible-ui.transcription-enabled {\n  width: calc(100vw - 40%) !important;\n  right: 20% !important;\n}\n\n.captions-canvas.visible-ui.transcription-enabled div.text-container {\n  left: 25% !important;\n}\n\n.popup-content.fixed.vertical-transcript{\n  width: 40% !important;\n  height: calc(100vh - var(--playback-bar-height) - 80px) !important;\n  right: 0px !important;\n  background-color: var(--main-bg-color) !important;\n  top: 0px !important;\n}\n\n.popup-content.fixed.vertical-transcript-sm{\n  width: 40% !important;\n  height: calc(100vh - var(--playback-bar-height) - 80px) !important;\n  right: 0px !important;\n  background-color: var(--main-bg-color) !important;\n  top: 0px !important;\n}\n\n.base-video-rect.dynamic.portrait.transcription {\n    right: 15% !important;\n    gap: 0 !important;\n}\n\n.base-video-rect.dynamic.portrait.transcription-sm {\n  right: 15%;\n  margin-left: 0px;\n  width: calc(100vw - 45%) !important;\n  gap: 0 !important;\n}\n\n.trancription-plugin-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.popup-content.fixed.vertical-transcript .center-container .ai-declaration {\n  text-align: right;\n  color: lightgray;\n  font-size: x-small;\n}\n\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tab-pane {\n  overflow: hidden;\n  display: flex;\n\n}\n\n.tab-pane .transcript-text p span.result-item {\n  cursor: pointer;\n  color: white;\n  margin: 0 2px;\n  display: inline;\n}\n\n.tab-pane .input-container {\n  position: relative;\n  display: inline-block;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.tab-pane .input-container .search-input {\n  flex: 1;\n  padding-right: 30px;\n}\n\n.clear-button {\n  position: absolute;\n  right: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  transform: translateY(-50%);\n  top: 50%;\n}\n\n.clear-button:hover {\n  color: #333; \n}\n\n.tab-pane input {\n  padding-left: 10px;\n  width: 100%;\n  height: var(--find-captions-plugin-search-bar-height);\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  float: right;\n  box-sizing: border-box;\n}\n\n.tab-pane .search-button {\n  position: absolute;\n  right: 5%;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.tab-pane .search-button:hover {\n  color: #333; \n}\n\n.tab-pane .search-content {\n    margin-bottom: 10px;\n}\n\n.tab-pane .transcript-text {\n  clear: both;\n}\n\n.tab-pane .transcript-text::before {\n  height: 20px;\n  content: \"\";\n}\n\n.tab-pane .transcript-text p span.result-item.current {\n  background-color: var(--highlight-bg-color-hover);\n  margin: 0 2px;\n}\n\n.tab-pane .transcript-text .highlight {\n  background-color: coral;\n}\n\n.tab-pane .transcript-text .current-highlight {\n  background-color: yellow;\n}\n\n.tab-content {\n  display: flex;\n  flex-direction: column;\n  padding: 5px 0px; \n  position: relative;\n  overflow: hidden;\n  height: calc(100vh - var(--playback-bar-height) - 180px);\n}\n\n.tab-contents {\n  flex-grow: 1;\n  overflow-y: auto;\n  margin-top: 3%;\n  max-height: 100%; \n}\n\n.ai-model-text {\n  position: relative;\n}\n\n.ai-model {\n  color: lightgray; \n  font-size: 12px;\n  text-align: center;\n  display: block;\n  flex-shrink: 0;\n}\n\n.ai-model button {\n  color: white;\n  background: none!important;\n  border: none;\n  padding: 0!important;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.ai-model .tab-icon svg{\n  font-size: 12px;\n  fill: lightgray;\n  vertical-align: middle;\n  width: 12px;\n  height: 12px;\n}\n\n.icon-description-list {\n  padding: 0;\n  list-style-type: none;\n}\n\n.icon-description-list li {\n  margin: 8px 0;\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.icon-description-list li .tab-icon {\n  margin-right: 8px;\n  width: 1em;\n  height: 1em;\n  cursor: pointer;\n  border: none;\n  background: none;\n  fill: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tabs {\n  display: flex;\n  padding: 20px 50px;\n  position: relative;\n  align-items: center;\n}\n\n.tab-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.left-tabs {\n  display: flex;\n}\n\n.right-tabs {\n  display: flex;\n  margin-left: auto;\n  margin-right: 10px;\n}\n\n.tab-button {\n  cursor: pointer;\n  border: none;\n  align-items: center;\n  text-align: center;\n  background: none;\n  padding-top: 0.25rem;\n}\n\n.tab-button .tab-icon {\n  display: inline-block;\n  width: var(--button-icon-size);\n  cursor: pointer;\n  border: none;\n  background: none;\n  fill: white;\n}\n\n\n.tab-button:hover {\n  background-color: var(--highlight-bg-color-hover);\n  color: white;\n  border-radius: 5px;\n}\n\n.tab-button.active {\n    background-color: var(--highlight-bg-color-hover);\n    color: white;\n    border-radius: 5px;\n}\n\n.tab-content .tab-pane {\n  display: none;\n}\n\n\n.tab-content .tab-pane.active {\n  display: flex;\n  max-height: calc(100vh - var(--playback-bar-height) - 95px) !important;\n  padding: 5px 10px;\n  flex-direction: column;\n}\n\n.tab-pane .dropdown-container .summary-language-dropdown {\n  width: 100%;\n  padding: 0 10px;\n  border-radius: 5px;\n  height: var(--find-captions-plugin-search-bar-height);\n  float: right;\n}\n\n.tab-pane .summary-text {\n  clear: both;\n}\n\n.tab-content .tab-pane div {\n  color: white;\n  padding-top: 1%;\n}\n\n.tab-open .dropdown-open .summary-language-dropdown {\n  display: block;\n}\n\n.tab-pane .dropdown-open .dropdown-icon {\n  display: none;\n}\n\n.tabs-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-bottom: 1px solid white;\n  padding-bottom: 10px;\n  padding-top: 25px;\n  position: sticky;\n  z-index: 9999;\n}\n\n.burger-menu {\n  display: none;\n}\n\n.dropdown-menu {\n  display: none;\n}\n\n.burger-menu.active .dropdown-menu {\n  display: block;\n  position: absolute;\n  background: var(--main-bg-color);\n  border: 1px solid var(--main-bg-color);\n  z-index: 1000; \n  right: 0px; \n}\n\n.dropdown-menu button {\n  padding: 10px;\n}\n\n.menu-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: white;\n}\n\n@media (max-width: 359px) {\n  .summary-language-dropdown {\n    width: 100% !important;\n  }\n\t\n  .right-tabs .tab-button {\n    display: none;\n  }\n\n  .burger-menu {\n    display: block;\n    margin-left: auto;\n    position: absolute;\n    float: right !important;\n  }\n\n  .dropdown-menu .tab-button .tab-icon {\n    width: 1.1rem;\n  }\n}\n\n/* Medium screens (360px to 430px) */\n@media (min-width: 360px) and (max-width: 430px) {\n   .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 79px) !important;\n    width: 40% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 135px) !important;\n    width: 50% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 155px) !important;\n  }\n\n  .summary-language-dropdown {\n    width: 100% !important;\n  }\n\n  .right-tabs .tab-button {\n    display: none;\n  }\n\n  .tabs-container {\n    padding-top: 35px !important;\n  }\n\n  .burger-menu {\n    display: block;\n    margin-left: auto;\n    position: absolute;\n    float: right !important;\n  }\n\n  .dropdown-menu .tab-button .tab-icon {\n    width: 1.1rem;\n  }\n}\n\n/* Large screens (431px and above) */\n@media (min-width: 431px) and (max-width: 539px) {\n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 78px) !important;\n    width: 40% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 118px) !important;\n    width: 40% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 175px) !important;\n  }\n\n  .summary-language-dropdown {\n    width: 100% !important;\n  }\n\n  .right-tabs .tab-button {\n    display: none;\n  }\n\n  .burger-menu {\n    display: block;\n    margin-left: auto;\n    position: absolute;\n    float: right !important;\n  }\n\n  .dropdown-menu .tab-button .tab-icon {\n    width: 1.1rem;\n  }\n}\n\n@media (min-width: 540px) and (max-width: 719px) {\n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 33px) !important;\n    width: 35% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 158px) !important;\n  }\n\n  .summary-language-dropdown {\n    width: 80% !important;\n  }\n\n  .right-tabs .tab-button {\n    display: none;\n  }\n\n  .burger-menu {\n    display: block;\n    margin-left: auto;\n    position: absolute;\n    float: right !important;\n  }\n\n  .dropdown-menu .tab-button .tab-icon {\n    width: 1.1rem;\n  }\n\n}\n\n@media (min-height: 720px) and (min-width: 540px) and (max-width: 767px){ \n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 80px) !important;\n    width: 35% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 80px) !important;\n  }\n}\n\n/* Specific styles for iPads (or tablets) */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 122px) !important;\n  }\n  .right-tabs .tab-button {\n    display: block;\n  }\n\n  .burger-menu {\n    display: none;\n  }\n\n  .tab-button .tab-icon {\n    width: 1.1rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 115px) !important;\n  }\n\n  .summary-language-dropdown {\n    width: 40% !important;\n  }\n\n  .right-tabs .tab-button {\n    display: block;\n  }\n\n  .burger-menu {\n    display: none;\n  }\n}\n\n@media (min-width: 1280px) {\n  .popup-content.fixed.vertical-transcript-sm {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 35% !important;\n  }\n\n  .popup-content.fixed.vertical-transcript {\n    height: calc(100vh - var(--playback-bar-height) - 32px) !important;\n    width: 30% !important;\n  }\n\n  .tab-content {\n    height: calc(100vh - var(--playback-bar-height) - 115px) !important;\n  }\n\n  .right-tabs .tab-button {\n    display: block;\n  }\n\n  .summary-language-dropdown {\n    width: 40% !important;\n  }\n\n  .burger-menu {\n    display: none;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
